

















































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeUser from '@/stores/modules/user';

import Checked from '@/components/Checked.vue';
import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import TableCell from '@/components/Paginate/TableCell.vue';

@Component({
	components: {
		Checked,
		CrudList,
		TableHead,
		TableCell,
	}
})
export default class CrudUserList extends Vue {
	
	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	
	private storeUser = storeUser;
}
